import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { GLOBAL_IMAGES } from "../assets/asset";
import UseAuthToken from "../hooks/useAuthToken";

const VerificationPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const email = location.state?.email || "";
  const [message, setMessage] = useState("");
  const [timer, setTimer] = useState(60);
  const token = UseAuthToken();

  const apiCall = async (url, method, body = null) => {
    try {
      const response = await fetch(url, {
        method,
        headers: {
          Authorization: `${process.env.REACT_APP_AUTH_TOKEN_DEV}`,
          "Content-Type": "application/json",
          jwt: token,
        },
        body: body ? JSON.stringify(body) : null,
      });
      if (!response.ok) {
        throw new Error("API request failed");
      }
      return response;
    } catch (err) {
      throw new Error("An error occurred. Please check your connection.");
    }
  };

  const handleResend = async () => {
    try {
      await apiCall(`${process.env.REACT_APP_BASE_URL}api/sendlink`, "POST", {
        email,
      });
      setMessage("Verification email has been resent!");
      setTimer(60);
    } catch (err) {
      setMessage(
        err.message || "Failed to resend verification email. Please try again."
      );
    }
  };

  useEffect(() => {
    const interval = setInterval(() => {
      setTimer((prev) => (prev > 0 ? prev - 1 : 0));
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div
      className="min-h-screen flex items-center justify-center bg-gray-50 font-mali"
      style={{
        backgroundImage: `url(${GLOBAL_IMAGES.onboarding_bg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div className="bg-white bg-opacity-60 p-8 rounded-lg shadow-lg px-6 md:px-20 w-full max-w-4xl">
        <h2 className="text-3xl font-bold font-mali text-center  text-gray-800 mb-6">
          Verify Your Email
        </h2>

        <div className="justify-center  flex ">
          <svg
            width="150"
            height="150"
            viewBox="0 0 269 270"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M89.667 54.3H215.2a49.314 49.314 0 0 1 49.317 49.316v76.217H40.35v-76.217A49.316 49.316 0 0 1 89.667 54.3"
              fill="#266CAD"
            />
            <path d="M4.484 81.2h152.433v98.634H4.484z" fill="#FA9F0C" />
            <path d="m156.917 81.2-76.216 58.284L4.484 81.2z" fill="#FFB531" />
            <path d="M116.567 197.766h35.867v67.25h-35.867z" fill="#D9D9D7" />
            <path d="M116.567 197.766h35.867v13.45h-35.867z" fill="#CFCFCD" />
            <path
              d="M264.517 103.616v76.217H138.984v-76.217A49.33 49.33 0 0 0 89.667 54.3H215.2a49.314 49.314 0 0 1 49.317 49.316"
              fill="#348FD9"
            />
            <path
              d="M188.3 139.483c7.428 0 13.45-6.022 13.45-13.45s-6.022-13.45-13.45-13.45-13.45 6.022-13.45 13.45 6.022 13.45 13.45 13.45"
              fill="#D75246"
            />
            <path d="M188.3 4.984h35.866v26.9H188.3z" fill="#C74242" />
            <path d="M183.817 4.984h8.967V121.55h-8.967z" fill="#D75246" />
            <path d="M4.484 179.833h134.5v17.933H4.484z" fill="#E0E0DE" />
            <path d="M138.984 179.833h125.533v17.933H138.984z" fill="#CFCFCD" />
            <path
              d="M215.2 49.817h-13.45v8.966h13.45a44.885 44.885 0 0 1 44.833 44.834v44.833H269v-44.833a53.86 53.86 0 0 0-53.8-53.8"
              fill="#000"
            />
            <path
              d="M260.033 175.35H143.467v-71.733a53.43 53.43 0 0 0-15.76-38.039 54.3 54.3 0 0 0-8.277-6.795h64.387v49.885a17.93 17.93 0 0 0-13.307 19.623 17.94 17.94 0 0 0 17.79 15.674 17.935 17.935 0 0 0 14.843-27.998 17.93 17.93 0 0 0-10.36-7.299V36.367h31.384a4.483 4.483 0 0 0 4.483-4.484v-26.9A4.48 4.48 0 0 0 224.167.5H188.3a4.483 4.483 0 0 0-4.483 4.483v44.834h-94.15A53.58 53.58 0 0 0 52.74 64.49l6.159 6.52a44.824 44.824 0 0 1 62.468.909 45 45 0 0 1 4.165 4.798H4.483A4.483 4.483 0 0 0 0 81.2v116.567a4.483 4.483 0 0 0 4.483 4.483h107.6v62.767a4.487 4.487 0 0 0 4.484 4.483h35.866a4.485 4.485 0 0 0 4.484-4.483v-53.8h-8.967v49.316h-26.9V202.25h143.467a4.48 4.48 0 0 0 4.483-4.483v-40.35h-8.967zm-62.766-49.317a8.97 8.97 0 0 1-5.536 8.284 8.96 8.96 0 0 1-9.771-1.943 8.968 8.968 0 0 1 6.34-15.307 8.98 8.98 0 0 1 8.967 8.966M219.683 27.4h-26.9V9.467h26.9zM50.587 122.099l-41.62 46.082V90.273zm7.146 5.465 20.244 15.481a4.48 4.48 0 0 0 5.446 0l20.246-15.482 30.831 34.14v13.647H14.574zm53.082-5.465 23.685-18.111v44.336zm22.548-28.529L80.7 133.84 17.727 85.683h113.042a44.3 44.3 0 0 1 2.594 7.887M8.967 184.317H134.5v8.966H8.967zm251.066 8.966H143.467v-8.966h116.566z"
              fill="#000"
            />
            <path
              d="M152.433 157.417h8.967v8.966h-8.967zM174.85 18.433V9.467a31.417 31.417 0 0 0-31.383 31.383h8.966a22.445 22.445 0 0 1 22.417-22.417"
              fill="#000"
            />
          </svg>
        </div>

        <p className="text-center font-mali font-semibold text-xl mb-4">
          We've sent a verification link to your email address,{" "}
          <span className="text-indigo-600 font-bold">{email}</span>. Please
          open your email and click on the link to confirm your account.
        </p>
        <p className="text-center text-gray-600 mb-8">
          Please check your email and click the verification link to continue.
        </p>
        <div className="flex flex-col items-center space-y-3">
          <div className="flex flex-col items-center space-y-2">
            <button
              onClick={handleResend}
              disabled={timer > 0}
              className={`w-fit px-10 font-mulish font-semibold bg-[#08059B] text-white py-2 rounded-lg hover:bg-blue-900${
                timer > 0
                  ? "opacity-50 cursor-not-allowed"
                  : "hover:text-blue-900"
              }`}
            >
              {timer > 0 ? `Resend in ${timer}s` : "Resend Verification Link"}
            </button>
          </div>

          <p className="text-gray-700 text-sm text-center">
            If you get verified then click on Login button.
          </p>
          <button
            onClick={() => navigate("/login")}
            className="text-blue-600 font-semibold underline hover:text-blue-700 transition"
          >
            Login Now 
          </button>
        </div>
        {message && (
          <p className="text-green-500 text-sm mt-4 text-center">{message}</p>
        )}
      </div>
    </div>
  );
};

export default VerificationPage;
